// Crossing the mobile breakpoint (a resize, or a tablet rotating across 768px) changes values
// that have transitions on them - .site-nav's width/translate, the header's translate - so the
// browser animated the layout switch itself like a state change: the nav panel slid across the
// screen, and going back to desktop the in-flow nav grew/shrank for 0.2s, re-laying out the whole
// page (and firing every block's ResizeObserver) each frame.
//
// So for the one style recalc where the breakpoint flips, every transition is off
// ([data-breakpoint-switch], globals.css): the attribute goes on, a forced style read computes the
// new breakpoint's values with transition: none (nothing to animate from), and it comes off again
// next frame - by then only `transition` itself changes, which starts nothing.

const MOBILE_QUERY = "(max-width: 767px)";

export function initBreakpointTransitions(): void {
    window.matchMedia(MOBILE_QUERY).addEventListener("change", () => {
        const root = document.documentElement;
        root.setAttribute("data-breakpoint-switch", "");
        void root.offsetWidth;
        requestAnimationFrame(() => root.removeAttribute("data-breakpoint-switch"));
    });
}
